import React from 'react';
import './DropdownmenuStyle.css';

const Dropdownmenu = ({ options, viewdropdown, onChange }) => {
    return (
        <div className={`dropdowncontent tabDropMenu ${(viewdropdown && options?.length > 0) ? 'active' : ''}`}>
            <ul>
                {options?.map((item, index) => (
                    <li>
                        <span key={index} onClick={() => onChange(item.value)} >{item.label}</span>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Dropdownmenu